import styled from 'styled-components'
import { breakpoints } from '../../styles/vars/breakpoints.style'
import { mq } from '../../styles/vars/media-queries.style'

export const GridItemMain = styled.div`
  ${props => {
    const columnSpanStyles = Object.keys(breakpoints).reduce(
      (stylesString, breakpointName) => {
        let styles = stylesString

        if (props[breakpointName]) {
          const colSpan = props[`${breakpointName}Start`]
            ? `${props[`${breakpointName}Start`]} / `
            : ''

          const heightSpan = props[`${breakpointName}Height`]
            ? `grid-row: span ${props[`${breakpointName}Height`]};`
            : ``

          styles = `${styles}
            ${mq[breakpointName]} {
              grid-column: ${colSpan}span ${props[breakpointName]};
              ${heightSpan}
            }
          `
        }

        if (props[`${breakpointName}Order`]) {
          styles = `${styles}
            ${mq[breakpointName]} {
              order: ${props[`${breakpointName}Order`]};
            }
          `
        }

        if (props[`${breakpointName}Align`]) {
          styles = `${styles}
            ${mq[breakpointName]} {
              -ms-grid-row-align: ${props[`${breakpointName}Align`]};
              align-self: ${props[`${breakpointName}Align`]};
            }
          `
        }

        return styles
      },
      ``
    )

    return `
      grid-column: 1 / span ${props.colCount};
      ${columnSpanStyles}
    `
  }}
`
